import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

const StarRating = ({ rating }) => {
  if (rating === 0) {
    return null
  }

  const renderStars = () => {
    const filledStars = rating || 0
    const emptyStars = 5 - filledStars

    const stars = []

    for (let i = 0; i < filledStars; i++) {
      stars.push(
        <FontAwesomeIcon
          key={`filledStar_${i}`}
          className="filledStar"
          icon={faStar}
        />,
      )
    }

    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <FontAwesomeIcon
          key={`emptyStar_${i}`}
          className="emptyStar"
          icon={faStar}
        />,
      )
    }

    return stars
  }

  return <div>{renderStars()}</div>
}

export default StarRating
